<template>
  <div>
    <default-table
      :items="listaFaturas"
      :fields="colunas"
      :striped="false"
      :busy="flags.carregandoDados.status"
      :tbody-tr-class="definirClasseLinha">
      <template #empty>
        <em>Nenhum registro encontrado.</em>
      </template>
      <template #cell(data_vencimento)="row">
        {{$date(row.item.data_vencimento).format('DD/MM/YYYY')}}
      </template>
      <template #cell(data_emissao)="row">
        {{$date(row.item.data_emissao).format('DD/MM/YYYY')}}
      </template>
      <template #cell(valor_total)="row">
        {{ formatarValorMonetario(row.item.valor_total) }}
      </template>
      <template #cell(descricao)="row">
        <slot name="descricao" :row="row.item">
        </slot>
      </template>
      <template #cell(status)="row">
        <span :class="{'statusPago': row.item.status === 1,
                      'statusPendente': row.item.status === 2 || row.item.status === 4,
                      'statusAberto': row.item.status === 3}">
          {{ obterDescricaoStatusFatura(row.item.status) }}
        </span>
      </template>
      <template #cell(acoes)="row">
        <slot name="acoes" :row="row.item">
        </slot>
      </template>
    </default-table>
    <pagination :fonteDeDados="componentePaginacao.fonteDeDados" :disabled="flags.carregandoDados.status" @navegarNaPaginacao="obterDadosPaginados"/>
  </div>
</template>

<script>
import ListagemFaturas from './js/listagem-faturas'
export default ListagemFaturas
</script>

<style scoped>
@import "./scss/faturas.scss";
</style>
